import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  ResolveFn,
  Router,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { GlobalService } from "../services/global.service";

@Injectable()
export class orderDetailsResolver implements Resolve<any[]> {
  constructor(private globalService: GlobalService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return;
    
    // return this.globalService.getOrderDetails();
    // //   catchError((error) => {
    // //     console.log(error);
    // //     this.router.navigate(["/app"]);
    // //     return of(null);
    // //   })
    // // );
  }
}
